// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ebdea247","977":"f3b1eeb0"}[chunkId] + ".chunk.js";
};